import React from 'react';

const DeliveryNoteForm = (props) => (
  <form>
    <div className="form-group">
      <textarea
        type="text"
        onChange={props.handleChange('deliveryNote')}
        placeholder="Masukkan detail pengiriman"
        className="form-control"
        values={props.values.deliveryNote}
        />
    </div>
  </form>
)


export default DeliveryNoteForm;
